import React from "react";
import Expenses from "../../Components/Expenses/Expenses";

const ExpensesIndex = () => {
  return (
    <div>
      <Expenses />
    </div>
  );
};

export default ExpensesIndex;
